import React from 'react';

const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-GB', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
};

function ArticlePreviewModal({ isOpen, onClose, formData, categories, authorName }) {
    if (!isOpen) return null;

    const categoryName = categories.find(c => c.id === formData.categoryId)?.name || 'Uncategorised';

    return (
        <div className="fixed inset-0 z-[200] flex flex-col overflow-hidden">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-black bg-opacity-70" />

            {/* Modal container */}
            <div className="relative flex flex-col w-full h-full overflow-hidden">
                {/* Preview banner */}
                <div
                    className="relative z-10 flex items-center justify-between px-4 py-2 bg-maroon text-white flex-shrink-0"
                    style={{ boxShadow: '0 2px 0 0 rgba(0,0,0,0.4)' }}
                >
                    <span className="font-['Jersey_10'] uppercase text-[15px] tracking-[2px]">
                        ⚠ Draft Preview — Not Published
                    </span>
                    <button
                        onClick={onClose}
                        className="font-['Jersey_10'] uppercase text-[14px] tracking-[1px] bg-white text-maroon px-4 py-1 hover:bg-gray-100 transition-colors"
                        style={{ boxShadow: '0 2px 0 0 rgba(0,0,0,0.3)' }}
                    >
                        Close Preview
                    </button>
                </div>

                {/* Scrollable article content */}
                <div className="relative z-10 flex-1 overflow-y-auto bg-gray-100 p-4 lg:p-6">
                    <div className="max-w-6xl mx-auto">
                        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-6">
                            {/* Main article column */}
                            <div className="lg:col-span-8 min-w-0">
                                {/* Article header box */}
                                <div
                                    className="bg-offwhite border-2 border-gray-800 mb-4"
                                    style={{ boxShadow: '0 4px 0 0 rgba(0,0,0,0.5)' }}
                                >
                                    {/* Category + title */}
                                    <div className="p-4 border-b border-gray-300">
                                        <span
                                            className="inline-block font-['Jersey_10'] uppercase text-[11px] tracking-[1px] text-white px-2 py-0.5 mb-2"
                                            style={{ backgroundColor: 'rgba(90,41,41,0.85)', boxShadow: '0 2px 0 0 rgba(0,0,0,0.3)' }}
                                        >
                                            {categoryName}
                                        </span>
                                        <h1 className="font-['Jersey_10'] uppercase text-[22px] tracking-[1px] text-gray-900 leading-tight">
                                            {formData.title || 'Untitled Article'}
                                        </h1>

                                        <div className="flex items-center gap-3 mt-2 text-xs text-gray-500 font-['Jersey_10'] uppercase tracking-wide">
                                            <span>By {authorName || 'You'}</span>
                                            <span>·</span>
                                            <span>{formatDate(formData.publicDate || new Date().toISOString())}</span>
                                        </div>
                                    </div>

                                    {/* Header image */}
                                    {formData.headerImage && (
                                        <div className="w-full bg-gray-200 border-b border-gray-300 overflow-hidden flex items-center justify-center p-5 pb-10 relative">
                                            <img
                                                src={formData.headerImage}
                                                alt={formData.title}
                                                className="max-w-full"
                                            />
                                            {formData.source && (
                                                <span className="absolute bottom-0 right-2 bg-gray-300 py-1.5 px-2.5 text-xs">
                                                    Source: {formData.source}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    {/* Article body */}
                                    <div className="p-4">
                                        {formData.articleText ? (
                                            <div
                                                className="article-content space-y-3 text-sm leading-relaxed text-gray-800"
                                                dangerouslySetInnerHTML={{ __html: formData.articleText }}
                                            />
                                        ) : (
                                            <p className="text-gray-400 italic text-sm">No article content yet.</p>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Sidebar column */}
                            <div className="lg:col-span-4 min-w-0 space-y-4">
                                {/* Draft indicator */}
                                <div
                                    className="bg-offwhite border-2 border-gray-800 p-4"
                                    style={{ boxShadow: '0 4px 0 0 rgba(0,0,0,0.5)' }}
                                >
                                    <p className="font-['Jersey_10'] uppercase text-[14px] tracking-[1px] text-maroon mb-1">
                                        Draft Preview
                                    </p>
                                    <p className="text-xs text-gray-600">
                                        This is how your article will look when published. The sidebar here would normally show latest articles and other widgets.
                                    </p>
                                    {formData.spotlight && (
                                        <p className="mt-2 text-xs text-gray-600">
                                            ★ This article is marked as a <strong>Spotlight</strong> article.
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ArticlePreviewModal;